import { useMutation } from '@tanstack/react-query';
import { WrappedExportResponse } from 'com.cogvio.pricemonitor.api';
import { apiClientMutator } from '~/infrastructure/config/mutator';

export function deleteProductGroupProducts(userId: string, groupId: string, productIds: string[]) {
	return apiClientMutator<void>({
		url: `/users/${userId}/product-groups/${groupId}/products`,
		method: 'delete',
		data: { items: productIds.map((id) => ({ id })) },
	});
}

export function postProductGroupExportXls(userId: string, groupId: string, currency: string) {
	return apiClientMutator<WrappedExportResponse>({
		url: `/users/${userId}/product-groups/${groupId}/export-xls`,
		method: 'post',
		data: JSON.stringify({ currency }),
	});
}

export function postProductGroupExportEvidence(userId: string, groupId: string) {
	return apiClientMutator<WrappedExportResponse>({
		url: `/users/${userId}/product-groups/${groupId}/export-evidence`,
		method: 'post',
	});
}

export function useProductGroupExportXls(
	userId: string,
	options: {
		onSuccess?: (response: WrappedExportResponse) => void;
		onError?: (error: unknown) => void;
	} = {}
) {
	return useMutation({
		mutationFn: ({ groupId, currency }: { groupId: string; currency: string }) =>
			postProductGroupExportXls(userId, groupId, currency),
		onSuccess: options.onSuccess,
		onError: options.onError,
	});
}

export function useProductGroupExportEvidence(
	userId: string,
	options: {
		onSuccess?: (response: WrappedExportResponse) => void;
		onError?: (error: unknown) => void;
	} = {}
) {
	return useMutation({
		mutationFn: ({ groupId }: { groupId: string }) => postProductGroupExportEvidence(userId, groupId),
		onSuccess: options.onSuccess,
		onError: options.onError,
	});
}
